import { branchConstants } from "../actions/constants/branchConstants";

export const enableBranchesReducer = (state = {}, action: any) => {
  switch (action.type) {
    case branchConstants.enableBranchesRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case branchConstants.enableBranchesSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case branchConstants.enableBranchesFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const createBranchReducer = (state = {}, action: any) => {
  switch (action.type) {
    case branchConstants.createBranchRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case branchConstants.createBranchSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case branchConstants.createBranchFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const listBranchesReducer = (state = {}, action: any) => {
  switch (action.type) {
    case branchConstants.listBranchesRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case branchConstants.listBranchesSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case branchConstants.listBranchesFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const switchTenantReducer = (state = {}, action: any) => {
  switch (action.type) {
    case branchConstants.switchTenantRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case branchConstants.switchTenantSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case branchConstants.switchTenantFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};
